import { render, staticRenderFns } from "./FreddiesFlowers.vue?vue&type=template&id=05f2a784&"
import script from "./FreddiesFlowers.vue?vue&type=script&lang=js&"
export * from "./FreddiesFlowers.vue?vue&type=script&lang=js&"
import style0 from "./FreddiesFlowers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports